




























import {Component, Mixins, Watch} from 'vue-property-decorator';

import IconCache from '@/mixins/IconCache';

import DefaultLayout from '@/layouts/default.vue';
import ErrorLayout from '@/layouts/error.vue';
import Modal from '@/components/Modal.vue';
import ModalMixin from '@/mixins/ModalMixin';

import Preloader from '@/components/Preloader.vue';
//
import {getScrollDirection, scrollToTypes} from '@/utils';
import Anal from '@/anal.ts';

@Component({
	components: {
		'default-layout': DefaultLayout,
		'error-layout': ErrorLayout,
		'v-modal': Modal,
		'v-preloader': Preloader,
		//'v-cookies': Cookies,
		'v-anal': Anal,
	}
})
export default class App extends Mixins(IconCache, ModalMixin) {

	scrollToInfo: scrollToTypes = this.$store.state.scrollToInfo;

	iconsToPrefetch: string[] = [
		'logo/blue',
		'logo/white-blue',
		'logo/green',
		'logo/gold',
		'logo/white',
		'logo/preloader',
		'logo/loader',
		'ui/back-to-top',

		'cards/gold',
		'cards/green',
		'cards/white',

		'letters/a',

		'symbols/cards/gold',
		'symbols/cards/white',
		'symbols/cards/green',

		'symbols/letters/a-blue',
		'symbols/letters/a-gold',
		'symbols/letters/a-white',
		'symbols/letters/a-green',

		'symbols/ui/mock',

		'ui/globe',
		'ui/pin',
		'ui/search',
		'ui/select-arrow',
		'ui/mouse',
		'ui/thanks',
		'ui/close',

		'ui/categoryRocket',
		'ui/categoryCard',
		'ui/categoryGlobus',
		'ui/categoryLoan',
		'ui/categoryOther',
		'ui/categoryPhone',
		'ui/callUs',
		'ui/chatUs',
		'ui/writeUs',

		'ui/yes',
		'ui/no',

		'ui/fb',
		'ui/ig',
		'ui/in',
		'ui/tw',
		'ui/yt',

		'ui/googlePlay',
		'ui/appStore',
		'ui/contactUs',

		'benefits/green/card-valid',
		'benefits/green/download',
		'benefits/green/face-id',
		'benefits/green/finger',
		'benefits/green/message',
		'benefits/green/notification',
		'benefits/green/savings',
		'benefits/green/user-valid',

		'cards/section/card-white-map',
	];

	get layout(): string {
		return `${this.$route.meta.layout || 'error'}-layout`;
	}

	get slug(): string | null {
		return this.$route.query.hasOwnProperty('modal') ? this.$route.query.modal! as string : null;
	}

	get showPreloader(): boolean {
		return this.$route.name!.indexOf('index') > -1 && !this.$store.state.global.preloaded;
	}

	@Watch('$route', {deep: true})
	async onRouteChanged(): Promise<void> {
		await this.$store.dispatch('updateMenu', {
			isOpen: false
		});
		await this.handleModalSlug();
	}

	async created(): Promise<void> {
		await this.handleModalSlug();
	}

	async beforeCreate(): Promise<void> {
		if (typeof window !== 'undefined' && sessionStorage.getItem('preloaded')) {
			await this.$store.dispatch('preloaded', true);
		}
	}

	mounted() {
		if (typeof window === 'undefined') {
			return;
		}
		window.addEventListener('scroll', this.scrollHandler);

		this.$nextTick(() => {
			if (this.$store.state.global.isMobile) {
				this.$root.$emit('isLoaded', true);
			}
		});
	}

	async handleModalSlug(): Promise<void> {
		const slug = this.$route.query.modal;
		if (typeof slug === 'undefined' || slug === null) {
			await this.$store.dispatch('hideModals');
			return;
		}
		this.toggleModal(slug as string);
	}

	scrollHandler() {
		this.$store.dispatch('scrollToInfo', getScrollDirection(this.scrollToInfo));
	}

	beforeDestroy() {
		window.removeEventListener('scroll', this.scrollHandler);
	}


}
